import { create } from "apisauce";

const apiClient = create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 150000,
    withCredentials: true,
});

export default apiClient;
